import {AnalysisGraphQL, GetAnalysisPipelineStep} from 'analysis-tool/AnalysisTypes';

import {getFlagRowsStepSystemNamesFromAncestorSteps} from './getDataFrameRenderOverrides';

export function getFlaggedRowsFromDataFrame(
  analysis: AnalysisGraphQL,
  step: GetAnalysisPipelineStep,
  dataFrameRows: JSONScalar
): Set<string> {
  const {flagColumn} = getFlagRowsStepSystemNamesFromAncestorSteps(analysis, step);
  if (flagColumn == null) {
    return new Set();
  }
  const selectedRows = new Set<string>();
  dataFrameRows.forEach((row: JSONScalar, index: number) => {
    if (row[flagColumn] === true) {
      selectedRows.add(index.toString());
    }
  });
  return selectedRows;
}
